import { Link } from "react-router-dom";
import ScrollReveal from "./ScrollReveal";

const modules = [
  { number: "01", title: "Custom AI agents for operations" },
  { number: "02", title: "Automated competitive intelligence" },
  { number: "03", title: "Content and marketing engines" },
  { number: "04", title: "Data pipeline automation" },
  { number: "05", title: "Security and governance frameworks" },
  { number: "06", title: "Customer intelligence systems" },
];

export default function AISystems() {
  return (
    <section id="ai-systems" aria-label="AI Systems Layer" className="editorial-container section-spacing">
      <hr className="editorial-rule mb-16 lg:mb-20" />

      {/* Label */}
      <ScrollReveal>
        <p className="font-mono text-label uppercase tracking-[0.05em] text-accent">
          AI SYSTEMS LAYER
        </p>
      </ScrollReveal>

      {/* Headline */}
      <ScrollReveal stagger={1}>
        <h2 className="mt-6 max-w-3xl font-display text-section font-bold text-foreground md:text-section-md lg:text-section-lg">
          AI Systems Layer
        </h2>
      </ScrollReveal>

      {/* Subtitle */}
      <ScrollReveal stagger={2}>
        <p className="mt-4 max-w-2xl text-body-lg text-foreground-muted md:text-body-lg-md">
          Your AI team-in-a-box. Applied only when the foundation is ready.
        </p>
      </ScrollReveal>

      {/* Intro */}
      <ScrollReveal stagger={3}>
        <p className="mt-8 max-w-3xl text-foreground-muted md:text-body-md">
          AI is the accelerant, not the foundation. Tools without strategy are
          expensive toys.
        </p>
      </ScrollReveal>

      {/* Available Modules */}
      <ScrollReveal className="mt-12">
        <h3 className="font-display text-subsection font-semibold text-foreground md:text-subsection-md">
          Available Modules
        </h3>
      </ScrollReveal>

      <div className="mt-10 grid gap-8 md:grid-cols-2 md:gap-x-16 md:gap-y-8">
        {modules.map((mod, i) => (
          <ScrollReveal
            key={mod.number}
            stagger={Math.min(i + 1, 5) as 1 | 2 | 3 | 4 | 5}
          >
            <article className="border-t border-accent pt-5">
              <span className="font-mono text-number text-accent">
                {mod.number}
              </span>
              <p className="mt-3 text-foreground-muted">{mod.title}</p>
            </article>
          </ScrollReveal>
        ))}
      </div>

      {/* Footer callout */}
      <ScrollReveal className="mt-16">
        <div className="border-l-2 border-accent bg-accent-subtle py-4 pl-6">
          <p className="text-body-lg font-medium text-foreground md:text-body-lg-md">
            These systems plug into your foundation, not into chaos.
          </p>
        </div>
      </ScrollReveal>

      <ScrollReveal className="mt-10">
        <Link
          to="/ai-systems"
          className="group inline-flex items-center gap-2 font-body text-cta uppercase text-accent transition-all duration-300 hover:gap-4"
        >
          FULL AI SYSTEMS DETAILS
          <span aria-hidden="true" className="inline-block transition-transform duration-300 group-hover:translate-x-0.5">→</span>
        </Link>
      </ScrollReveal>
    </section>
  );
}
